import { FontAwesome5 } from '@expo/vector-icons';
import { styled, ThemeType } from '@openeducation/oe-it-themes';
import { rgba } from 'polished';
import React from 'react';
import { StyleProp, ViewStyle, TouchableOpacity } from 'react-native';

export interface OECheckboxProps {
  onPress: () => void;
  size?: number;
  isChecked?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
  style?: StyleProp<ViewStyle>;
  checkedStyle?: StyleProp<ViewStyle>;
  accessibilityLabel?: string;
}

export const OECheckbox = ({
  isChecked,
  size = 16,
  onPress,
  containerStyle,
  style,
  checkedStyle,
  accessibilityLabel,
}: OECheckboxProps) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={containerStyle}
      accessibilityLabel={accessibilityLabel}
    >
      <Content
        style={isChecked ? checkedStyle : style}
        isChecked={isChecked}
        size={size}
      >
        {isChecked && <CheckIcon size={size} />}
      </Content>
    </TouchableOpacity>
  );
};

type ContentType = {
  size: number;
  isChecked?: boolean;
};

const Content = styled.View<ContentType>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: ${({ size }) => size / 8}px;
  border-width: 1px;
  border-color: ${({ theme, isChecked }) =>
    isChecked ? theme.color.primary : rgba(theme.color.primaryLight, 0.25)};
  background-color: ${({ theme, isChecked }) =>
    isChecked ? theme.color.primary : theme.color.background};
  justify-content: center;
  align-items: center;
`;

type CheckIconType = {
  theme: ThemeType;
  size: number;
};

const CheckIcon = styled(FontAwesome5).attrs(
  ({ theme, size }: CheckIconType) => ({
    color: theme.color.white,
    name: 'check',
    size: size * 0.65,
  })
)<CheckIconType>``;

export default OECheckbox;
